export default __webpack_public_path__ + "static/media/insta_logo.bacb96e1.png";